import styled from 'styled-components';
import { SkeletonInput, SkeletonAvatar, Avatar, theme } from 'components';

export const StyledSkeletonAvatar = styled(SkeletonAvatar)`
  padding-right: 25px;
`;

export const StyledContactsAvatar = styled(Avatar)`
  background-color: ${theme.gray6};
  color: ${theme.white};
`;

export const StyledSkeletonInput = styled(SkeletonInput)`
  width: 100%;
`;
